var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_971_3446)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.2881,
    y: 1.34961,
    width: 74.8472,
    height: 74.8472,
    rx: 16,
    transform: "rotate(12 27.2881 1.34961)",
    fill: "#077882",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 24.3037,
    width: 73.8472,
    height: 73.8472,
    rx: 15.5,
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 24.3037,
    width: 73.8472,
    height: 73.8472,
    rx: 15.5,
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0735 62.0241L41.9623 65.1352M45.0735 65.1352L41.9623 62.0241M33.9127 62.0241L30.8015 65.1352M33.9127 65.1352L30.8015 62.0241M34.8639 71.3423C36.5614 69.6448 39.3136 69.6448 41.011 71.3423M25.588 49.2216H26.3995M31.9998 49.2216H32.8113M38.4117 49.2216H39.2232M56.375 55.4431H19.5V47.6875C19.5 45.0987 21.5987 43 24.1875 43H51.6875C54.2763 43 56.375 45.0987 56.375 47.6875V55.4431Z",
    stroke: "#077882",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.375 73.8111V55.4434H19.5V73.7941C19.5 76.383 21.5987 78.4816 24.1875 78.4816H51.6875C54.2706 78.4816 56.3658 76.3921 56.375 73.8111Z",
    stroke: "#077882",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_971_3446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99.9996,
    height: 100,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoHistory);
export default __webpack_public_path__ + "static/media/noHistory.d92c21ee264e13a22c57f4c9ddb4c59c.svg";
export { ForwardRef as ReactComponent };